import type { FC } from 'react';

import { TPO_IMPORT_EVENTS_FOOTER, TPO_IMPORT_EVENTS_RECORD_COUNT } from '../../../config/testIds';

export interface ImportEventsFooterProps {
    /** Rows currently in the table — grows as the scroller pages more in. */
    loadedCount: number;
    totalCount: number;
    selectedCount: number;
}

/**
 * Counter under the events table.
 *
 * The table has no pager, so this is the only signal that more rows exist
 * behind a scroll. Once rows are selected the wording switches to the selection
 * count: selections are preserved across pages, so the number a user cares
 * about is no longer tied to what is currently loaded.
 */
const ImportEventsFooter: FC<ImportEventsFooterProps> = ({ loadedCount, totalCount, selectedCount }) => (
    <div
        className="flex items-center h-8 px-3 border-t border-[#e4e4e7] text-xs text-[#52525c]"
        data-testid={TPO_IMPORT_EVENTS_FOOTER}
    >
        <p
            className="whitespace-nowrap"
            data-testid={TPO_IMPORT_EVENTS_RECORD_COUNT}
            data-state-loaded-count={loadedCount}
            data-state-total-count={totalCount}
            data-state-selected-count={selectedCount}
        >
            {selectedCount > 0
                ? `${selectedCount.toLocaleString()} selected of ${totalCount.toLocaleString()}`
                : `Showing ${loadedCount.toLocaleString()} of ${totalCount.toLocaleString()} records`}
        </p>
    </div>
);

ImportEventsFooter.displayName = 'ImportEventsFooter';
export default ImportEventsFooter;
